/************
 Swipers
 ************/

const productV31Swipers = {};
const productV31Thumbs = {};

// play video in the currently active slide (videos are muted + loop, so we never pause)
function playActiveSlideVideoV29(swiper) {
    const activeSlide = swiper.slides[swiper.activeIndex];
    const video = activeSlide?.querySelector("video");
    if (!video) {
        return;
    }
    video.play();
}

document.querySelectorAll('.productV31Visual').forEach(function (visual) {
    const productId = visual.dataset.productId;

    productV31Thumbs[productId] = new Swiper(`#productV31ThumbnailsSwiper-${productId}`, {
        slidesPerView: "auto",
        spaceBetween: 5,
        breakpoints: {
            800: {
                slidesPerView: 6,
            }
        },
        loop: true,
        navigation: {
            nextEl: `#productV31ThumbnailsNext-${productId}`,
            prevEl: `#productV31ThumbnailsPrev-${productId}`,
        },
    });

    productV31Swipers[productId] = new Swiper(`#productV31Swiper-${productId}`, {
        navigation: {
            nextEl: `#productV31Swiper-${productId} .productV31SwiperNext`,
            prevEl: `#productV31Swiper-${productId} .productV31SwiperPrev`,
        },
        loop: true,
        thumbs: {
            swiper: productV31Thumbs[productId]
        },
        on: {
            init: function () {
                playActiveSlideVideoV29(this);
            },
            slideChange: function () {
                playActiveSlideVideoV29(this);
            }
        }
    });

    visual.querySelectorAll('.productV31GalleryItem').forEach(function (element) {
        element.addEventListener('click', function () {
            // gallery items map 1:1 to logical slides; slideToLoop keeps loop-mode clones from skewing the index
            productV31Swipers[productId].slideToLoop(getElIndex(this));
        });
    });
});

/********************
 Video Popup
 *******************/

// open video
document.querySelectorAll('.productV31Video')?.forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        const popup = document.querySelector(".videoPopup");
        popup.showModal();

        // check if we're on mobile and if .videoPopupVideo.mobileOnly exists
        if (window.innerWidth < 800 && popup.querySelector(".videoPopupVideo.mobileOnly")) {
            popup.querySelector(".videoPopupVideo.mobileOnly").play();
        } else {
            popup.querySelector("video").play();
        }
    })
})


/*****************
 Reviews
 ****************/

document.querySelector("#productV31Review")?.addEventListener("click", function () {
    window.scrollTo({
        top: document.querySelector("#looxReviews").offsetTop - 100,
        behavior: "smooth"
    });
})


// Update swiper to correct product
function switchProductV29Visual(productId) {
    document.querySelectorAll('.productV31Visual').forEach(function (v) {
        v.classList.toggle('active', v.dataset.productId === String(productId));
    });

    // this swiper was likely built while its visual was display:none (so every slide measured 0px and loop math broke); re-measure now that it's visible or navigation stays dead until the next slideTo
    productV31Thumbs[productId]?.update();
    productV31Swipers[productId]?.update();
}

// update active variant
function updateProductV18(skipImage) {

    // find the selected product radio and parse its product JSON
    const selectedProductInput = document.querySelector('.productV31GroupsLabelInput:checked');
    const product = JSON.parse(selectedProductInput.value);

    switchProductV29Visual(product.id);

    // scope variant lookups to this product's group so a leftover :checked from another product doesn't leak in
    const selectedProductLabel = selectedProductInput.closest('.productV31GroupsLabel');

    // if no variant in this product's group is checked, default to the first
    if (!selectedProductLabel.querySelector('.productV31GroupsLabelBodyInputsLabelInput:checked')) {
        // slide to the first image and set skipImage to true
        productV31Swipers[product.id].slideToLoop(0);
        skipImage = true;

        selectedProductLabel.querySelector('.productV31GroupsLabelBodyInputsLabelInput').checked = true;
    }

    activeVariant = product.variants.filter((variant) => {
        return variant.id === parseInt(selectedProductLabel.querySelector(".productV31GroupsLabelBodyInputsLabelInput:checked").value)
    })[0];


    // find variant image — match by filename since product.media slide ids no longer line up with variant.featured_image.id
    if (activeVariant.featured_image && !skipImage) {
        const activeVisual = document.querySelector(`.productV31Visual[data-product-id="${product.id}"]`);
        const variantFilename = activeVariant.featured_image.src.split("/").pop().split("?")[0];
        // find the slide by filename, including loop clones (a clone carries the same logical index as its original)
        const variantSlide = Array.from(activeVisual.querySelectorAll(".productV31SwiperSlide")).find(slide => {
            const img = slide.querySelector("img");
            return img && img.src.split("/").pop().split("?")[0] === variantFilename;
        });
        // read Swiper's own logical index off the slide; loop mode rotates slides in the DOM so DOM position drifts after wrapping past the start
        if (variantSlide) {
            productV31Swipers[product.id].slideToLoop(parseInt(variantSlide.dataset.swiperSlideIndex));
        }
    }

    // this specific variant should always show the first slide regardless of its featured image
    if (activeVariant.id === 48167894286586) {
        productV31Swipers[product.id].slideToLoop(0);
    }

    // is the variant available?

    let variantPrice = activeVariant.price;
    let compareAtPrice = activeVariant.compare_at_price;

    // update display
    if (variantPrice < compareAtPrice) {
        const savingsPct = Math.round((compareAtPrice - variantPrice) / compareAtPrice * 100);
        document.querySelector("#productV31PriceCompare").textContent = price(compareAtPrice, true);
        document.querySelector("#productV31PriceActual").textContent = price(variantPrice, true);
        document.querySelector("#productV31PriceSavings").textContent = `SAVE ${savingsPct}%`;
        document.querySelector("#productV31PriceSavings").classList.add('active');
    } else {
        document.querySelector("#productV31PriceCompare").textContent = "";
        document.querySelector("#productV31PriceActual").textContent = price(variantPrice, true);
        document.querySelector("#productV31PriceSavings").classList.remove('active');
    }


    // check if the variant is in stock
    if (activeVariant.available) {
        document.querySelector("#productV31ATC").classList.remove("oos");
        document.querySelector("#productV31ATC").textContent = document.querySelector("#productV31ATC").dataset.text;
    } else {
        document.querySelector("#productV31ATC").classList.add("oos");
        document.querySelector("#productV31ATC").textContent = "Sold Out — Notify Me When Available";
    }

    // show the default or other dropdown content based on the checked group input
    const isDefaultGroup = document.querySelector('.productV31GroupsLabelInput:checked').classList.contains('default');
    const targetClass = isDefaultGroup ? 'default' : 'other';
    document.querySelectorAll('.productV31DropdownContentTxt').forEach(function (element) {
        element.classList.remove('active');
        if (element.classList.contains(targetClass)) {
            element.classList.add('active');
        }
    })

}

/*******************
 Product Form
 ********************/

document.querySelectorAll(".productV31GroupsLabelBodyInputsLabelInput").forEach(function (element) {
    element.addEventListener("change", function () {
        const parentInput = this.closest(".productV31GroupsLabel").querySelector(".productV31GroupsLabelInput");
        if (parentInput && !parentInput.checked) {
            parentInput.checked = true;
        }
    });
});

document.querySelectorAll(".productV31Groups input").forEach(function (element) {
    element.addEventListener("change", function () {
        updateProductV18();
    });
});

/****************
 *  Quantity
 *************/

let quantity = 1;


/**************
 Product ATC
 ***************/

// add to cart button
/*Code for adding Shipping Insurance*/
document.querySelector("#productV31ATC").addEventListener("click", async function (e) {
    e.preventDefault();

    // check for out of stock
    if (this.classList.contains("oos")) {
        // check email
        let {value: email} = await Swal.fire({
            title: product.title,
            text: "Enter your email to be notified when this product is back in stock.",
            input: "email",
            inputPlaceholder: "Email Address",
            confirmButtonText: "Notify Me When Available",
        });

        // confirm email is returned
        if (!email) {
            return;
        }

        // add to waitlist
        let formData = new FormData();
        formData.append("a", await klaviyo.account());
        formData.append("email", email);
        formData.append("g", "");
        formData.append("variant", activeVariant.id);
        formData.append("product", product.id);
        formData.append("platform", "shopify");
        formData.append("subscribe_for_newsletter", false);
        fetch("https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", {
            method: "POST",
            body: formData
        })

        // show success message
        await Swal.fire({
            title: "Success!",
            text: "You will be notified when this product is back in stock.",
            confirmButtonText: "OK",
        });

        return;
    }

    // add loading animation
    this.classList.add("loading");

    // create form data
    let formData = {
        items: []
    };


    // normal product
    formData.items.push({
        quantity: quantity,
        id: activeVariant.id
    });


    // check if we should go directly to checkout
    if (this.classList.contains('checkout')) {

        await clearCart();

        // add gift free gift
        formData.items.push(
            {
                quantity: 1,
                id: 47175294222586
            }
        )
        await addProduct(formData)

        window.location.href = '/checkout';

        // klaviyo tracking
        try {
            _learnq.push(['track', 'Added to Cart', item]);
        } catch (error) {
            console.error("Klaviyo tracking not found");
        }

        // remove loading animation
        this.classList.remove("loading");

        return;
    }


    // add productV31
    await addProduct(formData);

    // klaviyo tracking
    try {
        _learnq.push(['track', 'Added to Cart', item]);
    } catch (error) {
        console.error("Klaviyo tracking not found");
    }


    // open cart
    await openCart();


    // remove loading animation
    this.classList.remove("loading");

});

//space
// atc call to action
document.querySelectorAll(`.button[href="#add_to_cart"]`).forEach(function (element) {
    element.addEventListener("click", async function (e) {
        e.preventDefault();

        // click normal atc
        document.querySelector("#productV31ATC").click();

        // start/stop loading
        this.classList.add("loading");
        await sleep(1000);
        this.classList.remove("loading");
    });
});

// atc call to action
document.querySelectorAll(`.button[href="#add_to_cart_addon"]`).forEach(function (element) {
    element.addEventListener("click", async function (e) {
        e.preventDefault();

        // check the addon if not already checked
        if (!document.querySelector("#productV31AddonCheckboxInput").checked) {
            document.querySelector("#productV31AddonCheckbox").click();
        }


        // click normal atc
        document.querySelector("#productV31ATC").click();

        // start/stop loading
        this.classList.add("loading");
        await sleep(1000);
        this.classList.remove("loading");
    });
});

/**************
 Sticky ATC
 ***************/

// ignore if noSticky class is present
if (!document.querySelector("#productV31ATC").classList.contains("noSticky")) {
    const stickyAtcObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                document.querySelector("#productV31ATC").classList.remove("sticky");
            } else {
                document.querySelector("#productV31ATC").classList.add("sticky");
            }
        });
    }, {
        rootMargin: "-100px 0px 0px 0px"
    })
    stickyAtcObserver.observe(document.querySelector("#productV31Content"));

}


// event listeners for dropdown items
document.querySelectorAll(`.productV31DropdownTop`).forEach(function (element) {
    element.addEventListener("click", function () {
        this.parentElement.classList.toggle("active");
    });
});

/**************
 Shipping Time
 ***************/

// Consistent random number generation using the hash as a seed
function generateSeededRandom(key, min, max) {
    let hash = 0;
    for (let i = 0; i < key.length; i++) {
        hash = (hash << 5) - hash + key.charCodeAt(i);
        hash |= 0;
    }

    const x = Math.sin(hash) * 10000;
    const seed = x - Math.floor(x);

    return Math.floor(seed * (max - min + 1) + min);
}

let ordersRemaining = localStorage.getItem('ordersRemaining');

// check local storage for orders remaining and set
if (ordersRemaining && localStorage.getItem('productHandle') === product.handle) {
    if (document.querySelector('#productV31ShippingRemainingTxt')) {
        document.querySelector('#productV31ShippingRemainingTxt').textContent = `${ordersRemaining} orders remaining`;
    }
} else {
    // generate random number and set local storage if not found
    ordersRemaining = generateSeededRandom(product.handle, 10, 100);
    localStorage.setItem('ordersRemaining', ordersRemaining);
    localStorage.setItem('productHandle', product.handle);

    if (document.querySelector('#productV31ShippingRemainingTxt')) {
        document.querySelector('#productV31ShippingRemainingTxt').textContent = `${ordersRemaining} orders remaining`;
    }
}

// show shipping tomorrow
let date = new Date();
date.setDate(date.getDate() + 1);
date = date.toLocaleDateString('en-US', {month: 'short', day: 'numeric'});
document.querySelector('#productV31ShippingDateTxt').innerHTML = `Ships <strong>Tomorrow, ${date}</strong>`;


// check local storage for orders remaining and set
if (ordersRemaining && localStorage.getItem('productHandle') === product.handle) {
    document.querySelector('#productV31ShippingRemainingTxt').textContent = `${ordersRemaining} orders remaining`;
} else {
    // generate random number and set local storage if not found
    ordersRemaining = generateSeededRandom(product.handle, 10, 100);
    localStorage.setItem('ordersRemaining', ordersRemaining);
    localStorage.setItem('productHandle', product.handle);
    document.querySelector('#productV31ShippingRemainingTxt').textContent = `${ordersRemaining} orders remaining`;
}